// extracted by mini-css-extract-plugin
module.exports = {"tab":"styles_tab__2VOdW","active":"styles_active__2fswc","error":"styles_error__1EiOD"};